<template>
    <div class="modal fade fade-scale modal-wrapper" v-show="visible" id="subscribe-modal" role="dialog"
         aria-labelledby="subscribe-modal-label" aria-hidden="false" @click="close">
        <div class="alert-wide modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="row">
                        <div class="swal2-icon d-flex swal2-info justify-content-center">
                            <div class="swal2-icon-content">
                                <i class="far fa-envelope-open"></i>
                            </div>
                        </div>
                    </div>

                    <h4 v-if="results && results > 0" class="text-center blink text-danger">WE FOUND MATCHING
                        FLIGHTS</h4>

                    <div class="row justify-content-center">
                        <h3 v-if="!secondChance" class="m-5">{{ getPopUpTitle('subscribe-modal-first-chance') }}</h3>
                        <h3 v-if="secondChance" class="m-5">{{ getPopUpTitle('subscribe-modal-second-chance') }}</h3>
                        <div class="test" v-if="!secondChance" v-html="getPopUpBody('subscribe-modal-first-chance')"></div>
                        <div class="test" v-if="secondChance" v-html="getPopUpBody('subscribe-modal-second-chance')"></div>
                    </div>

                    <ValidationObserver v-slot="{ dirty, invalid }">
                        <div class="row">
                            <div class="col-12 mt-5">
                                <ValidationProvider name="Email" rules="required|email" v-slot="{ errors }">
                                    <div class="input-group mb-3">
                                        <input v-model="email" type="email" class="form-control"
                                               placeholder="Enter your email" aria-label="Guest email">
                                    </div>
                                    <div class="invalid-feedback">{{errors[0]}}</div>
                                </ValidationProvider>
                            </div>

                            <div class="col-12 mt-5">
                                <ValidationProvider name="Phone" rules="phoneRestriction|required" v-slot="{ errors } " >
                                    <div class="input-group mb-3">
                                        <input v-model="phone" type="text" class="form-control"
                                               placeholder="Enter your phone" aria-label="Guest phone" v-mask="'(###) ###-####'">
                                    </div>
                                    <div class="invalid-feedback">{{errors[0]}}</div>
                                </ValidationProvider>
                            </div>

                            <div v-if="errorMessages.length > 0" class="col-12 mt-7">
                                <div
                                v-for="errorMessage in errorMessages"
                                :key="errorMessage"
                                class="invalid-feedback"
                                >{{errorMessage}}</div>
                            </div>
                            <div class="col-12 mt-7">
                                <!-- <p class="text-center">
                                <small class="text-center">By registering and entering your email address and/or phone number you agree to be contacted both by email & phone. Message and data rates may apply.</small>
                                </p> -->
                            </div>


                            <div class="col-12 text-center m-5 p-5">
                                <button id="guest-user-subscription" class="btn btn-light-blue mx-5" @click="subscribe" type="button"
                                        :disabled="invalid || !dirty">
                                    Proceed
                                </button>
                                <button id="guest-user-subscription-reject" class="btn btn-secondary mx-5" @click="cancel" type="button">
                                    No thanks
                                </button>
                            </div>
                        </div>
                    </ValidationObserver>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import httpClient from '@/utils/httpClient';
    import axios from 'axios';
    import PopUpMixin from '@/mixins/dinamicPopUpMixin';

    export default {
        mixins:[PopUpMixin],
        props: {
            results: {
                default: null
            },
            visible: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                email: '',
                phone: '',
                errorMessages: [],
                secondChance: false,
                userIp:''
            }
        },
        methods: {
            close($event) {
                if ($event.target.classList.value.split(' ').includes('modal-wrapper')) {
                    console.log('close modal')
                }
            },
            cancel() {
                if (!this.secondChance) {
                    this.secondChance = true
                } else {
                    this.secondChance = false
                    this.$emit('close')
                }
            },
            subscribe() {
                this.errorMessages = [];
                const email = this.email;
                const phone = this.phone;

                if (this.email) {
                    axios.post('/api/statistics', {name: 'GUESTS_SUBSCRIBE_SUBMITTED_DAILY'})
                    axios.post('/api/statistics', {name: 'GUESTS_SUBSCRIBE_SUBMITTED'})
                }

                fetch('https://api.ipify.org?format=json')
                .then(response => response.json())
                .then(response => {
                    const ip = response.ip;
                    httpClient.post(`/api/subscribe_user`, {email, phone, ip })
                    .then(({user}) => {
                        this.$emit('subscribed', email, phone, user !== null);
                    })
                    .catch((err) => {
                        const errors = err.response.data.errors
                        let fields = Object.keys(errors)
                        this.errorMessages = fields.map(field => errors[field][0])
                    });
                })
                .catch(()=> {
                    httpClient.post(`/api/subscribe_user`, {email, phone})
                    .then(({user}) => {
                        this.$emit('subscribed', email, phone, user !== null);
                    })
                    .catch((err) => {
                        if (err.response) {
                            this.message = 'You must enter a valid '+err.response.data.errors.errorField[0];
                        }
                    });
                });

            }
        },
        watch: {
            visible(newVal) {
                if (newVal) {
                    axios.post('/api/statistics', {name: 'GUESTS_SUBSCRIBE_ASKED'});
                    axios.post('/api/statistics', {name: 'GUESTS_SUBSCRIBE_ASKED_DAILY'});
                }
            }
        },
    }
</script>

<style>
    #subscribe-modal {
        background: rgba(0, 0, 0, 0.45);
    }

    #subscribe-modal.fade:not(.show) {
        opacity: 1;
        display: block;
    }

    .blink {
        animation: blink-animation 1s steps(5, start) infinite;
        -webkit-animation: blink-animation 1s steps(5, start) infinite;
    }

    @keyframes blink-animation {
        to {
            visibility: hidden;
        }
    }

    @-webkit-keyframes blink-animation {
        to {
            visibility: hidden;
        }
    }

    .alert-wide {
        max-width: 950px !important;
    }

    .swal2-icon {
        padding: .1em .2em .3em;
    }

    /*.swal2-icon.swal2-info {*/
    /*    border-color: #3fc3ee;*/
    /*    color: #3fc3ee;*/
    /*}*/
    .swal2-icon .swal2-icon-content {
        display: flex;
        align-items: center;
        font-size: 3.75em;
    }

    div.modal-content {
        border: none;
        /*border-radius: 10px;*/
    }

    div.modal-body {
        padding: 15px 45px;
    }

    .btn-login {
        cursor: pointer;
        font-size: 80%;
        font-weight: 400;
        font-family: sans-serif;
    }

    @media (max-width: 600px) {
        #subscribe-modal .modal-content {
        max-height: 600px;
        overflow: scroll;
        }
    }
</style>
